import { useEffect, useState } from "react";
import { SelectionBar } from "./components/SelectionBar";
import { TabHeader } from "./components/TabHeader";
import { TableData } from "./components/TableData";
import { UpdateFavouriteModal } from "@components/templates/UpdateFavouriteModal";
import { profileType } from "@utils/enum";
import ContactModal from "@shared/country-components/contactModal";
import LocalStorageService from "@core/services/local-storage.service";
import { FavouriteDeleteModal } from "@components/templates/Favourite/FavouriteDeleteModal";
import SalesforceDuplicateModal from "@shared/salesforce-duplicate-modal";
import { useDispatch, useSelector } from "react-redux";
import { closeSalesforceModal, loadingBookmarkData, resetBookmarkData } from "@redux/Bookmark/bookmarksSlice";
import { getFavouriteDetailsHandler } from "@redux/Bookmark/bookmark.action";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import IntelLayout from "@components/layout/layout";
import { portsPayload } from "./utils/constant";
import { FavouriteNoData } from "../../components/templates/Favourite/FavouriteNoData/FavouriteNoData";
import { FavouriteDownloadModal } from "@components/templates/Favourite/FavouriteDownloadModal";

export const PortsBookmark = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [showFavModal, setShowFavModal] = useState(false);
  const [selectedCompanyArray, setSelectedCompanyArray] = useState([]);
  const [showContactModal, setShowContactModal] = useState(false);
  const [clearSelectedCompanies, setClearSelectedCompanies] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const [payload, setPayload] = useState(portsPayload);
  const [type, setType] = useState(profileType.ports);
  const bookmarkDetails = useSelector((state) => state.bookmarkDetails);
  const [perPage, setPerPage] = useState(10);
  const [currentpage, setCurrentPage] = useState(1);
  const [singleData, setSingleData] = useState({});
  const [search, setSearch] = useState("");
  const [filterCount, setFilterCount] = useState(0);

  const localStorageService = LocalStorageService.getService();
  const dispatch = useDispatch();
  const {
    duplicateSalesforce: { showDuplicateModal, duplicateCount, duplicateData, fuzzyData },
  } = bookmarkDetails;
  let timer = null;

  useEffect(() => {
    dispatch(loadingBookmarkData());
    dispatch(resetBookmarkData());
    dispatch(getFavouriteDetailsHandler({ payload: portsPayload }));
    setType(profileType.ports);
    setPayload(portsPayload);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const clearSelection = () => {
    setSelectedCompanyArray([]);
    let clearSelection = clearSelectedCompanies;
    setClearSelectedCompanies(!clearSelection);
    timer = setTimeout(() => {
      setClearSelectedCompanies(clearSelection);
    }, 200);
  };

  useEffect(() => {
    getCountHandler();
  }, [payload]);

  const getCountHandler = () => {
    if (payload && Object.keys(payload)?.length) {
      let count = 0;
      Object.keys(payload.filters)?.map((item) => {
        count += payload.filters[item].length;
      });
      setFilterCount(count);
    }
  };

  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      userDetails={() => {
        return;
      }}
      userPlanDetails={() => {
        return;
      }}
      type={"PortsBookmark"}
      pageTitle="Port Bookmarks | Trademo Intel">
      <div className="mt-3">
        {!bookmarkDetails?.bookmarkData?.loading && !bookmarkDetails?.bookmarkData?.data?.length && !search && !filterCount ? (
          <FavouriteNoData type={type} />
        ) : (
          <div>
            <div>
              <TabHeader setCurrentPage={setCurrentPage} clearSelection={clearSelection} type={type} search={search} setSearch={setSearch} payload={payload} setPayload={setPayload} />
            </div>
            {selectedCompanyArray.length ? <SelectionBar type={type} selectedCompanyArray={selectedCompanyArray} setDownloadModal={setDownloadModal} setShowDeleteModal={setShowDeleteModal} clearSelection={clearSelection} setShowContactModal={setShowContactModal} setShowFavModal={setShowFavModal} setSelectedCompanyArray={setSelectedCompanyArray} /> : null}
            {bookmarkDetails?.bookmarkData?.loading ? (
              <div className="mt-3">
                <LoadingSkeleton lines={10} lineHeight={"40px"} width={"100%"} shape="rectangle" widthArr={["100%", "100%", "100%", "100%"]} />
              </div>
            ) : !bookmarkDetails?.bookmarkData?.data?.length && (search || filterCount) ? (
              <FavouriteNoData type={type} message="No results match your search criteria" />
            ) : (
              <TableData singleData={singleData} setSingleData={setSingleData} currentpage={currentpage} setCurrentPage={setCurrentPage} perPage={perPage} setPerPage={setPerPage} setPayload={setPayload} payload={payload} type={type} clearSelectedCompanies={clearSelectedCompanies} showContactModal={showContactModal} setShowContactModal={setShowContactModal} selectedCompanyArray={selectedCompanyArray} showFavModal={showFavModal} setSelectedCompanyArray={setSelectedCompanyArray} setShowFavModal={setShowFavModal} />
            )}
            {showFavModal ? <UpdateFavouriteModal setPayload={setPayload} setSingleData={setSingleData} type={type} clearSelection={clearSelection} payload={payload} profileType={profileType.company} showFavModal={showFavModal} selectedCompanyArray={Object.keys(singleData).length ? [singleData] : selectedCompanyArray} setShowFavModal={setShowFavModal} /> : <></>}
            {showContactModal ? (
              <ContactModal
                show={showContactModal}
                prospectData={Object.keys(singleData).length ? [singleData] : selectedCompanyArray}
                currentUserPlan={localStorageService && localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : ""}
                remainingPhoneCount={100}
                remainingEmailCount={100}
                setSingleData={setSingleData}
                handleClose={() => {
                  setShowContactModal(false);
                  setSingleData({});
                }}
                type={type}
                clearSelection={clearSelection}
              />
            ) : null}
            {showDeleteModal ? <FavouriteDeleteModal setCurrentPage={setCurrentPage} type={type} setPayload={setPayload} clearSelection={clearSelection} payload={portsPayload} handleClose={() => setShowDeleteModal(false)} selectedCompanyArray={selectedCompanyArray} show={showDeleteModal} /> : <></>}
            {showDuplicateModal ? <SalesforceDuplicateModal closeButton={() => dispatch(closeSalesforceModal())} showButton={showDuplicateModal} duplicateCount={duplicateCount} duplicateData={duplicateData} fuzzyData={fuzzyData} type="companies" /> : <></>}
            {downloadModal ? <FavouriteDownloadModal type={type} clearSelection={clearSelection} downloadModal={downloadModal} handleClose={() => setDownloadModal(false)} selectedCompanyArray={selectedCompanyArray} /> : <></>}
          </div>
        )}
      </div>
    </IntelLayout>
  );
};
